<ng-container *ngIf="loggedIn">
  <app-mobile-promo *ngIf="showAppPromo$ | async"></app-mobile-promo>
  <app-editing-strategy *ngIf="step === 5 && editModeActive"></app-editing-strategy>
  <header [class.app-header]="!['/next/verify-email', '/greenness-survey'].includes(currentUrl)" *ngIf="step !== undefined || !email_confirmed">
    <app-navbar></app-navbar>
  </header>
  <app-dialog-promotions *ngIf="showPromotions$ | async"></app-dialog-promotions>
</ng-container>

<router-outlet *ngIf="activeHamburger === false"></router-outlet>
<app-toast-notifications></app-toast-notifications>
